import { reLoginUser } from "@/features/auth/UserSlice";
import { setReloginLoader } from "@/features/plans-and-subscription/subscriptionSlice";
import toastService from "@/services/toastService";
import { Axios } from "axios";

export const setupResponseInterceptors = (axiosInstance: Axios) => {
  // Response interceptor
  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // Handle error responses here (e.g., redirect to login on 401)
      // if (error.res.ponse && error.response.statusCode === 401) {
      // Handle unauthorized errors (e.g., log out the user)
      // }
      console.log("line 15", error.response);
      console.log("line 16", error.response.status);
      const ignoredPaths = ["/odoo/api/v1/projectLeads/getDetails"];

      const reqPath: string = error.request.responseURL;
      const status = error?.response?.status;
      // const statusText = error?.response?.statusText;
      const reloginRequired = error?.response?.headers["x-requires-relogin"];
  
    
      const shouldIgnoreErrorToast =
        ignoredPaths.some((path) => reqPath.endsWith(path)) ||
        (status === 403 && reloginRequired === "true");

        
      if (status === 403 && reloginRequired === "true") {
        import("@/store").then(({ store }) => {
          store.dispatch(setReloginLoader(true))
          store
            .dispatch(
              reLoginUser({ platform: 3 })
            )
            .unwrap()
            .then(() => {
              sessionStorage.setItem("triggerReLoginDialog", "true");
              
              window.dispatchEvent(new Event("open-relogin-dialog"));
            })
            .catch((err) => {
              console.error("Re-login failed", err);
            }).finally(() => {
              store.dispatch(setReloginLoader(false))
            })
        });

        return Promise.reject(error);
      }
      console.log("intercepted error", error, error.response.data.message, {
        shouldIgnoreErrorToast,
        reqPath,
      });
      if (!shouldIgnoreErrorToast) {
        toastService.error(
          error?.response?.data?.message || "An error occurred"
        );
      }
      return Promise.reject(error);
    }
  );
};
